import React, { createContext, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useStoreValues } from './GlobalContext/GlobalStateProvider';

const CreditContext = createContext();

export const CreditProvider = ({ children }) => {
  const { user } = useAuth();
  const { fetchCreditDetails } = useStoreValues();

  useEffect(() => {
    let intervalId;

    if (user) {
      fetchCreditDetails();

      intervalId = setInterval(() => {
        fetchCreditDetails();
      }, 300000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [user, fetchCreditDetails]);

  return <CreditContext.Provider value={{}}>{children}</CreditContext.Provider>;
};
